import React from 'react'
import { useTranslation } from 'react-i18next'
import { BaseView, BaseText } from '@/components/base'
import { useAuthScopedStore } from '@/store/scoped'
import { StickyHeaderNavigation } from '@/components/StickyHeaderNavigation'

export const ForgotPasswordEnterVerificationCodeHeader: React.FC = () => {
  const { t } = useTranslation()

  const recoveryMethod = useAuthScopedStore(
    (state) => state.recoverPasswordForm?.recoveryMethod,
  )
  const identificationMethod = useAuthScopedStore(
    (state) => state.identificationMethod,
  )
  const phone = useAuthScopedStore((state) => state.phone)
  const email = useAuthScopedStore((state) => state.email)

  // Use recoveryMethod first, fallback to identificationMethod for backwards compatibility
  const isRecoverPasswordWithEmail =
    recoveryMethod === 'email' || identificationMethod === 'email'

  const subtitleText = !isRecoverPasswordWithEmail
    ? t('screens:codeVerification.subtitle', {
        method: t('translation:phone'),
        value: `\u202A${phone?.countryCode} ${phone?.number}\u202C`,
      })
    : t('screens:codeVerification.subtitle', {
        method: t('translation:email'),
        value: email,
      })

  return (
    <BaseView gap={28}>
      <StickyHeaderNavigation />
      <BaseView gap={20} px={12}>
        <BaseText fontSize={24} fontFamily="semibold" color="label.default">
          {t('screens:codeVerification.title')}
        </BaseText>

        <BaseText fontSize={16} fontFamily="regular" color="label.description">
          {subtitleText}
        </BaseText>
      </BaseView>
    </BaseView>
  )
}
